export const QUOTE_LEVEL_FILES_DOWNLOAD_STATUSES = {
  MISSING: 'missing',
  UPLOADING: 'uploading',
  READY: 'ready',
} as const;

export type QUOTE_LEVEL_FILES_DOWNLOAD_STATUSES =
  (typeof QUOTE_LEVEL_FILES_DOWNLOAD_STATUSES)[keyof typeof QUOTE_LEVEL_FILES_DOWNLOAD_STATUSES];

export type DownloadQuoteLevelFilesResponseBody = {
  status: QUOTE_LEVEL_FILES_DOWNLOAD_STATUSES;
  message: string | null;
  downloadUrl: string | null;
};

export type DownloadQuoteLevelFilesRequestBody = {
  partFileUuids: string[];
};

export type DownloadQuoteLevelFilesRequestParams = {
  quoteId?: number;
};
